import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid as exportDataGridToExcel } from 'devextreme/excel_exporter';
import { exportPivotGrid } from 'devextreme/excel_exporter';

import dxDataGrid from "devextreme/ui/data_grid";
import dxPivotGrid from "devextreme/ui/pivot_grid";
import dxChart from "devextreme/viz/chart"
import { SvgUtils } from './svgUtils';
import { IReportOneUIComponent } from '../models/ReportTypes';
import ExtractorDataGridOptions from './ExtractorDataGridOptions';

const col2letter = (n) => {
    n = Math.max(0, n - 1);
    const a = 'ABCDEFGHIJKLMNOPQRSTUVWWYZ';
    let r = Math.floor(n / 26);
    let l = n % 26;
    let res = a[l];
    return (r > 0 ? col2letter(r) : '') + res;
}

const cell2str = (col0, row0, col1, row1) => {
    return col2letter(col0) + row0 + ":" + col2letter(col1) + row1;
}

export default class ExporterToExcel {
    //public static exportToExcel = async (reportName, components: Array<dxDataGrid | dxPivotGrid | dxChart>) => {
    public static exportToExcel = async (reportName, components: Array<IReportOneUIComponent>) => {
        const badSymbols = ["*", "?", ":", "\\", "/", "[", "]"];
        let repName = reportName;
        badSymbols.forEach(ch => {
            repName = repName.replaceAll(ch, " ");
        });
        const workbook = new Workbook();
        let pageNum = 0;
        const pagePrefix = "Страница ";
        for (let item of components) {
            if (!item) continue;
            if (!item.component) continue;
            if (item.component["_isHidden"] == true) continue;
            if (!((item.component["NAME"] == "dxDataGrid") || (item.component["NAME"] == "dxPivotGrid") || (item.component["NAME"] == "dxChart"))) continue;
            pageNum++;
            const worksheet = workbook.addWorksheet(item.title || pagePrefix + pageNum);
            if (item.component["NAME"] == "dxDataGrid") {
                let component = item.component as dxDataGrid;
                let searchText = ExtractorDataGridOptions.getSearchText(component);
                let filterText = await ExtractorDataGridOptions.getFilterText(component);
                if (filterText || searchText) {
                    const filterRow = worksheet.getRow(1);
                    filterRow.getCell(1).value = "Фильтр:";
                    if (searchText) {
                        worksheet.getRow(2).getCell(1).value = "Поисковая строка: " + searchText;
                        worksheet.getRow(3).getCell(1).value = filterText;
                    }
                    else {
                        worksheet.getRow(2).getCell(1).value = filterText;
                    }
                }
                await exportDataGridToExcel({
                    topLeftCell: { row: (filterText ? 4: 1), column: 1 },
                    component: item.component as dxDataGrid,
                    worksheet,
                    autoFilterEnabled: true,
                    customizeCell({ gridCell, excelCell }) {
                        if (gridCell.rowType == "data") {
                            if (gridCell.column.cellTemplate == "templateImage") {
                                excelCell.value = undefined;
                                const image = workbook.addImage({
                                    base64: gridCell.value,
                                    extension: 'png',
                                });
                                worksheet.addImage(image,
                                    cell2str(
                                        excelCell.col - 0,
                                        excelCell.row - 0,
                                        excelCell.col + 1,
                                        excelCell.row + 1 
                                    ));
                            }
                        }
                    },

                });
            }
            else if (item.component["NAME"] == "dxPivotGrid") {
                await exportPivotGrid({
                    component: item.component as dxPivotGrid,
                    worksheet,
                });
            }
            else if (item.component["NAME"] == "dxChart") {
                //https://stackoverflow.com/questions/28450471/convert-inline-svg-to-base64-string
                let img = await SvgUtils.svgImageToPngImage((item.component as dxChart).svg());
                const image = workbook.addImage({
                    base64: img.base64png,
                    extension: 'png',
                });
                worksheet.addImage(image, cell2str(1,1,10,28));
            }

        }
        if (pageNum > 0) {
            await workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), repName + '.xlsx');
            });
        }
    };
}

